const CAPTION_MENU_TIZEN = {
  bgColor: 'CAPTION_BG_COLOR_KEY',
  fgOpacity: 'CAPTION_FG_OPACITY_KEY',
  edgeColor: 'CAPTION_EDGE_COLOR_KEY',
  edgeType: 'CAPTION_EDGE_TYPE_KEY',
  fontSize: 'CAPTION_FONT_SIZE_KEY',
  fontStyle: 'CAPTION_FONT_STYLE_KEY',
  captionStyle: 'CAPTION_STYLE_KEY',
  fgColor: 'CAPTION_FG_COLOR_KEY',
  windowColor: 'CAPTION_WINDOW_COLOR_KEY',
  bgOpacity: 'CAPTION_BG_OPACITY_KEY',
  windowOpacity: 'CAPTION_WINDOW_OPACITY_KEY',
}

const CAPTION_MENU_VIZIO = {
  bgColor: 'background_color',
  fgOpacity: 'text_opacity',
  edgeColor: 'text_edges_color',
  edgeType: 'text_edges',
  fontSize: 'text_size',
  fontStyle: 'text_style',
  captionStyle: 'text_style',
  fgColor: 'text_color',
  windowColor: 'window_color',
  bgOpacity: 'background_opacity',
  windowOpacity: 'window_opacity',
}

const CAPTION_MENU_COMCAST = {
  bgColor: 'backgroundColor',
  fgOpacity: 'fontOpacity',
  edgeColor: 'fontEdgeColor',
  edgeType: 'fontEdge',
  fontSize: 'fontSize',
  fontStyle: 'fontFamily',
  fgColor: 'fontColor',
  bgOpacity: 'backgroundOpacity',
}
const CAPTION_COLOR_TIZEN = {
  1: 'white',
  2: 'black',
  3: 'red',
  4: 'green',
  5: 'blue',
  6: 'yellow',
  7: 'magenta',
  8: 'cyan',
}

const CAPTION_COLOR_VIZIO = {
  White: 'white',
  Black: 'black',
  Red: 'red',
  Green: 'green',
  Blue: 'blue',
  Yellow: 'yellow',
  Magenta: 'magenta',
  Cyan: 'cyan',
}

const CAPTION_COLOR_COMCASTX1FLEX = {
  '0xFFFFFFFF': 'white',
  '0xFF000000': 'black',
  '0xFFFF0000': 'red',
  '0xFF00FF00': 'green',
  '0xFF0000FF': 'blue',
  '0xFFFFFF00': 'yellow',
  '0xFFFF00FF': 'magenta',
  '0xFF00FFFF': 'cyan',
}

const CAPTION_COLOR_COMCASTXCLASS = {
  '#FFFFFF': 'white',
  '#000000': 'black',
  '#FF0000': 'red',
  '#008000': 'green',
  '#0000FF': 'blue',
  '#FFFF00': 'yellow',
  '#FF00FF': 'magenta',
  '#00FFFF': 'cyan',
}

const CAPTION_STYLE_TIZEN = {
  1: 'bold',
  2: 'italic',
}

const CAPTION_STYLE_VIZIO = {
  Bold: 'bold',
  Italic: 'italic',
}

const CAPTION_SIZE_TIZEN = {
  1: '70%',
  3: '130%',
  4: '160%',
}

const CAPTION_SIZE_VIZIO = {
  Small: '70%',
  Large: '130%',
  XLarge: '160%',
}

const CAPTION_SIZE_COMCASTX1FLEX = {
  11: '70%',
  29: '130%',
  42: '160%',
}

const CAPTION_SIZE_COMCASTX1CLASS = {
  0.5: '70%',
  1.5: '130%',
  2: '160%',
}

const CAPTION_FAMILY_TIZEN = {
  2: 'Courier New, monospace, serif',
  3: 'Times New Roman, serif',
  4: 'Arial, monospace, sans-serif',
  5: 'Tahoma, sans-serif',
  6: 'Comic Sans, serif',
  7: 'Brush Script, serif',
  8: 'Engravers Gothic, sans-serif',
}

const CAPTION_FAMILY_VIZIO = {
  Playbill: 'Courier New, monospace, serif',
  Newsprint: 'Times New Roman, serif',
  Computer: 'Arial, monospace, sans-serif',
  Modern: 'Tahoma, sans-serif',
  Casual: 'Comic Sans, serif',
  Script: 'Brush Script, serif',
  Capitals: 'Engravers Gothic, sans-serif',
}

const CAPTION_FAMILY_COMCAST = {
  monospaced_serif: 'Courier New, monospace, serif',
  proportional_serif: 'Times New Roman, serif',
  propotional_sans_serif: 'Arial, monospace, sans-serif',
  monospaced_sans_serif: 'Tahoma, sans-serif',
  casual: 'Comic Sans, serif',
  cursive: 'Brush Script, serif',
  small_capitals: 'Engravers Gothic, sans-serif',
}

const CAPTION_OPACITY_TIZEN = {
  2: '0.5',
  3: '0',
  5: '0.25',
  6: '0.75',
  1: 'flashing',
}

const CAPTION_OPACITY_VIZIO = {
  Transparent: '0',
  Translucent: '0.75',
  Flashing: 'flashing',
}

const CAPTION_OPACITY_COMCASTX1FLEX = {
  0: '0',
  50: '0.75',
}

const CAPTION_OPACITY_COMCASTX1CLASS = {
  0: '0',
  0.5: '0.75',
}

const CAPTION_EDGE_TIZEN = {
  1: 'raised',
  2: 'depressed',
  3: 'uniform',
  4: 'dropshadow',
}

const CAPTION_EDGE_VIZIO = {
  Raised: 'raised',
  Depressed: 'depressed',
  Uniform: 'uniform',
  DropShadow: 'dropshadow',
}

const CAPTION_EDGE_COMCAST = {
  raised: 'raised',
  depressed: 'depressed',
  uniform: 'uniform',
  drop_shadow_left: 'dropshadow',
  drop_shadow_right: 'dropshadow',
}

export function getStylesTizen() {
  const mappedMenuValues = Object.keys(CAPTION_MENU_TIZEN).reduce(
    (acc, key) => {
      acc[key] = window.webapis.tvinfo.getMenuValue(
        window.webapis.tvinfo.TvInfoMenuKey[CAPTION_MENU_TIZEN[key]]
      )
      return acc
    },
    {}
  )
  const getColor = (key) => {
    return CAPTION_COLOR_TIZEN[key] || null
  }
  const getOpacity = (key) => {
    return CAPTION_OPACITY_TIZEN[key] || '1'
  }
  const getEdgeType = (key) => {
    return CAPTION_EDGE_TIZEN[key] || 'none'
  }
  const getFontSize = (key) => {
    return CAPTION_SIZE_TIZEN[key] || '100%'
  }
  const getFontStyle = (key) => {
    return CAPTION_FAMILY_TIZEN[key] || 'sans-serif'
  }
  const getCaptionStyle = (key) => {
    return CAPTION_STYLE_TIZEN[key] || 'default'
  }

  const bgColor = getColor(mappedMenuValues.bgColor)
  const fgOpacity = getOpacity(mappedMenuValues.fgOpacity)
  const edgeColor = getColor(mappedMenuValues.edgeColor)

  const edgeType = getEdgeType(mappedMenuValues.edgeType)
  return {
    fontSize: getFontSize(mappedMenuValues.fontSize),
    fontStyle: getFontStyle(mappedMenuValues.fontStyle),
    captionStyle: getCaptionStyle(mappedMenuValues.captionStyle),
    fgColor: getColor(mappedMenuValues.fgColor),
    bgColor,
    windowColor: getColor(mappedMenuValues.windowColor),
    fgOpacity,
    bgOpacity: getOpacity(mappedMenuValues.bgOpacity),
    windowOpacity: getOpacity(mappedMenuValues.windowOpacity),
    textShadowValue: getTextShadowValue(
      edgeColor,
      edgeType,
      fgOpacity,
      bgColor
    ),
  }
}

export function getStylesVIZIO(rawVIZIOStyles) {
  const mappedStyles = Object.keys(CAPTION_MENU_VIZIO).reduce((acc, key) => {
    acc[key] = rawVIZIOStyles[CAPTION_MENU_VIZIO[key]]
    return acc
  }, {})

  const getColor = (key) => {
    return CAPTION_COLOR_VIZIO[key] || null
  }
  const getOpacity = (key) => {
    return CAPTION_OPACITY_VIZIO[key] || '1'
  }
  const getEdgeType = (key) => {
    return CAPTION_EDGE_VIZIO[key] || 'none'
  }
  const getFontSize = (key) => {
    return CAPTION_SIZE_VIZIO[key] || '100%'
  }
  const getFontStyle = (key) => {
    return CAPTION_FAMILY_VIZIO[key] || 'sans-serif'
  }
  const getCaptionStyle = (key) => {
    return CAPTION_STYLE_VIZIO[key] || 'default'
  }

  const bgColor = getColor(mappedStyles.bgColor)
  const fgOpacity = getOpacity(mappedStyles.fgOpacity)
  const edgeColor = getColor(mappedStyles.edgeColor)
  const edgeType = getEdgeType(mappedStyles.edgeType)
  return {
    fontSize: getFontSize(mappedStyles.fontSize),
    fontStyle: getFontStyle(mappedStyles.fontStyle),
    captionStyle: getCaptionStyle(mappedStyles.captionStyle),
    fgColor: getColor(mappedStyles.fgColor),
    bgColor,
    windowColor: getColor(mappedStyles.windowColor),
    fgOpacity,
    bgOpacity: getOpacity(mappedStyles.bgOpacity),
    windowOpacity: getOpacity(mappedStyles.windowOpacity),
    textShadowValue: getTextShadowValue(
      edgeColor,
      edgeType,
      fgOpacity,
      bgColor
    ),
  }
}

export function getStylesComcast(rawComcastX1OrXClassStyles, isXumo) {
  const mappedStyles = Object.keys(CAPTION_MENU_COMCAST).reduce((acc, key) => {
    acc[key] = rawComcastX1OrXClassStyles.styles[CAPTION_MENU_COMCAST[key]]
    return acc
  }, {})

  const getColor = (key) => {
    if (isXumo) {
      return CAPTION_COLOR_COMCASTXCLASS[key] || null
    } else {
      return CAPTION_COLOR_COMCASTX1FLEX[key] || null
    }
  }
  const getOpacity = (key) => {
    if (isXumo) {
      return CAPTION_OPACITY_COMCASTX1CLASS[key] || '1'
    } else {
      return CAPTION_OPACITY_COMCASTX1FLEX[key] || '1'
    }
  }
  const getEdgeType = (key) => {
    return CAPTION_EDGE_COMCAST[key] || 'none'
  }
  const getFontSize = (key) => {
    if (isXumo) {
      return CAPTION_SIZE_COMCASTX1CLASS[key] || '100%'
    } else {
      return CAPTION_SIZE_COMCASTX1FLEX[key] || '100%'
    }
  }
  const getFontStyle = (key) => {
    return CAPTION_FAMILY_COMCAST[key] || 'sans-serif'
  }

  const bgColor = getColor(mappedStyles.bgColor)
  const fgOpacity = getOpacity(mappedStyles.fgOpacity)
  const edgeColor = getColor(mappedStyles.edgeColor)
  const edgeType = getEdgeType(rawComcastX1OrXClassStyles.fontEdge)
  return {
    fontSize: getFontSize(mappedStyles.fontSize),
    fontStyle: getFontStyle(mappedStyles.fontStyle),
    captionStyle: 'default',
    fgColor: getColor(mappedStyles.fgColor),
    bgColor,
    windowColor: 'black',
    fgOpacity,
    bgOpacity: getOpacity(mappedStyles.bgOpacity),
    windowOpacity: '0',
    textShadowValue: getTextShadowValue(
      edgeColor,
      edgeType,
      fgOpacity,
      bgColor
    ),
  }
}

function getTextShadowValue(
  mappedEdgeColor,
  mappedEdgeType,
  mappedFgOpacity,
  mappedBgColor
) {
  const color = mapTextShadowColor(mappedEdgeColor, mappedBgColor)
  const isFgTransparent = mappedFgOpacity === '0'

  const colorPart =
    mappedEdgeType === 'none' && isFgTransparent
      ? `rgba(${color},0.5)`
      : `rgba(${color},0.8)`

  switch (mappedEdgeType) {
    case 'raised':
      return `${colorPart} -1px 0px 1px`
    case 'depressed':
      return `${colorPart} 3px 0px 1px`
    case 'uniform':
      return `${colorPart} 0px 0px 5px, ${colorPart} 0px 1px 5px, ${colorPart} 0px 2px 5px`
    case 'dropshadow':
      return `${colorPart} -3px 0px 2px`
    default:
      return isFgTransparent ? `${colorPart} -1px 0px 1px` : 'none'
  }
}

function mapTextShadowColor(mappedEdgeColor, mappedBgColor) {
  switch (mappedEdgeColor) {
    case 'white':
      return '255, 255, 255'
    case 'red':
      return '255, 0, 0'
    case 'green':
      return '0, 255, 0'
    case 'blue':
      return '0, 0, 255'
    case 'yellow':
      return '255, 255, 0'
    case 'magenta':
      return '255, 0, 255'
    case 'cyan':
      return '0, 255, 255'
    default:
      return mappedBgColor === 'black' ? '255, 255, 255' : '0, 0, 0'
  }
}
